export default "__VITE_ASSET__13085ae2__"